export default (slider) => {

    class Slider {
        constructor(slider){
            this.slider = slider;
            this.buttons = slider.querySelectorAll('.btn-slider');
            this.sliderShow = slider.querySelector('.slider-images');
            this.currentTriggered = 0;
            this.startX = 0;
            this.percentageMouv = 0;
            this.stepScreen = window.innerWidth / 2;
            
            this.handleStart = this.handleStart.bind(this);
            this.handleEnd = this.handleEnd.bind(this);
            this.handleMove = this.handleMove.bind(this);

            this.initTouch();
        }

        initTouch() {
            this.slider.addEventListener("touchstart", this.handleStart);
            this.slider.addEventListener("touchend", this.handleEnd);
            this.slider.addEventListener("touchmove", this.handleMove);
        }

        handleStart(e) {
            this.startX = e.changedTouches[0].pageX;
        }

        handleEnd(e) {
            let endX = e.changedTouches[0].pageX,
                buttonTriggered = this.slider.querySelector('.btn-slider.triggered');

            //Verif if user use buttons to translate slider
            this.currentTriggered = parseInt(buttonTriggered.getAttribute('data-target'));

            //If translate right to left
            if(this.percentageMouv < -30 && this.currentTriggered < this.buttons.length - 1 && endX < this.stepScreen){
                this.currentTriggered += 1;            
                let translate = "translateX(-" + this.currentTriggered * 100 + "%)";

                buttonTriggered.classList.remove('triggered');
                this.buttons[this.currentTriggered].classList.add('triggered');
                this.sliderShow.style.transform = translate;
                return
            }

            //If translate left to right
            if (this.percentageMouv >= 30 && this.currentTriggered > 0 && endX >= this.stepScreen) {
                this.currentTriggered -= 1;
                let translate = "translateX(-" + this.currentTriggered * 100 + "%)";
-
                buttonTriggered.classList.remove('triggered');
                this.buttons[this.currentTriggered].classList.add('triggered');
                this.sliderShow.style.transform = translate;
                return
            }

            //Return to current image if translate out of slidershow 
            let translate = "translateX(-" + this.currentTriggered * 100 + "%)";
            this.sliderShow.style.transform = translate;
        }

        handleMove(e) {
            let mouvX = e.changedTouches[0].pageX,
                diff = mouvX - this.startX;

            this.percentageMouv = diff * 100 / this.slider.offsetWidth;

            if(this.percentageMouv < 0) {
                let percentage = ( - this.currentTriggered * 100 ) + this.percentageMouv,
                    translate = "translateX(" + percentage + "%)";
                this.sliderShow.style.transform = translate;
                return
            }

            if(this.currentTriggered-1 >= 0){
                let percentage = (this.currentTriggered-1 * 100) + this.percentageMouv,
                    translate = "translateX(" + percentage + "%)";
                this.sliderShow.style.transform = translate;
                return
            }

            let translate = "translateX(" + this.percentageMouv + "%)";
            this.sliderShow.style.transform = translate;
        }
    }

    slider = new Slider(slider);
}